/* global BigInt */
import { isSportsbookHistoryDecimalString } from '../contracts/sportsbookHistoryResponse.contract.js';

export const INVALID_SPORTSBOOK_HISTORY_DECIMAL = '-';

const splitDecimal = (value) => {
  if (!isSportsbookHistoryDecimalString(value)) return null;
  const negative = value.startsWith('-');
  const unsigned = negative ? value.slice(1) : value;
  const [integer, fraction = ''] = unsigned.split('.');
  return { negative, integer, fraction };
};

const groupInteger = (value) => value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

const resolveDecimalUnit = (scale) => {
  if (scale === 2) return 100n;
  if (scale === 3) return 1000n;
  throw new RangeError(`Unsupported sportsbook history decimal scale: ${scale}`);
};

const roundDecimal = (decimal, scale) => {
  const unit = resolveDecimalUnit(scale);
  const padded = decimal.fraction.padEnd(scale + 1, '0');
  let scaled = (BigInt(decimal.integer) * unit) + BigInt(padded.slice(0, scale) || '0');
  if (padded[scale] >= '5') scaled += 1n;
  return {
    integer: String(scaled / unit),
    fraction: String(scaled % unit).padStart(scale, '0'),
  };
};

export const formatSportsbookHistoryMoney = (value) => {
  const decimal = splitDecimal(value);
  if (!decimal) return INVALID_SPORTSBOOK_HISTORY_DECIMAL;
  const rounded = roundDecimal(decimal, 3);
  const fraction = rounded.fraction.replace(/0+$/, '');
  const sign = decimal.negative ? '-' : '';
  return `${sign}${groupInteger(rounded.integer)}${fraction ? `.${fraction}` : ''}`;
};

export const formatSportsbookHistoryOdds = (value) => {
  const decimal = splitDecimal(value);
  if (!decimal) return INVALID_SPORTSBOOK_HISTORY_DECIMAL;
  const rounded = roundDecimal(decimal, 2);
  const sign = decimal.negative ? '-' : '';
  return `${sign}${rounded.integer}.${rounded.fraction}`;
};
